// AuthService.js
const login = async (userData) => {
  const { username, password } = userData;
  // console.log('AuthService',username, process.env.REACT_APP_DEFAULT_USER);
  // console.log('AuthService',password, process.env.REACT_APP_DEFAULT_PASS);

  await new Promise(resolve => setTimeout(resolve, 1000));  // Simular un delay

  if (username === process.env.REACT_APP_DEFAULT_USER && password === process.env.REACT_APP_DEFAULT_PASS) {
    const fakeResponseData = {
      accessToken: "fakeToken123456789",
      user: {
        name: "Usuario Ejemplo",
        username,
      },
    };

    localStorage.setItem('user', JSON.stringify(fakeResponseData));
    return fakeResponseData;
  } else {
    throw new Error('Credenciales incorrectas');
  }
};

const logout = () => {
  localStorage.removeItem('user');
};

const getCurrentUser = () => {
  return JSON.parse(localStorage.getItem('user'));
};

export { login, logout, getCurrentUser };
